<script>
export default {
  name: "POModal",
  data() {
    return {
      tableData: null,
      loading: false,
    };
  },
  created() {},
  methods: {
    getData(poId) {
      this.loading = true;
      this.tableData = [];
      this.$store
        .dispatch("inspectioniar/GetInspectionIar", poId)
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.showToast("Something went wrong - getting posted P.O", "error");
          this.loading = false;
        });
    },
    deleteIar(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, return it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("inspectioniar/DeleteInspectionIar", id)
            .then((res) => {
              if (res.status == 204) {
                this.deleteSuccesful();
              }
            })
            .catch((err) => {
              this.showToast("Cannot be returned!", "error");
            });
        }
      });
    },
    deleteSuccesful() {
      this.$emit("deleteSuccesful");
      this.$bvModal.hide("iar-modal");
      this.showToast("Successfully returned", "success");
    },
  },
};
</script>
<template>
  <b-modal
    id="iar-modal"
    title="Delivery Details"
    size="xl"
    title-class="font-20"
    hide-footer
    no-close-on-backdrop
  >
    <div class="d-flex flex-row-reverse mb-2">
      <button @click="deleteIar(tableData.id)" class="btn btn-sm btn-danger">
        <i class="mdi mdi-trash-can me-1"></i>Return Delivery
      </button>
    </div>
    <div
      class="h-50vh d-flex align-items-center justify-content-center"
      v-if="loading"
    >
      <div class="preloader-component me-2">
        <div class="status">
          <div class="spinner-chase w-25px h-25px">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      <h5 class="mb-0">Loading...</h5>
    </div>
    <div
      class="h-50vh d-flex align-items-center justify-content-center"
      v-else-if="!tableData"
    >
      <h5 class="text-muted">
        <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
      </h5>
    </div>
    <div v-else>
      <b-card no-body class="shadow-none position-relative">
        <b-card-header class="border" header-tag="header" role="tab">
          <div>
            <span>{{ tableData.po.poNumber }}</span>
            <h5 class="mb-0">{{ tableData.po.description }}</h5>
          </div>
        </b-card-header>
        <b-card-body class="border">
          <div class="row">
            <div class="col-md-3">
              <b>Delivery Details:</b>
              <div class="d-flex ms-3">
                <i class="me-2">-</i
                ><span>Invoice/DR Number: {{ tableData.drNumber }}</span>
              </div>
              <div class="d-flex ms-3">
                <i class="me-2">-</i
                ><span
                  >Date of Delivery:
                  {{ formatDate(new Date(tableData.dateOfDelivery)) }}</span
                >
              </div>
              <div class="d-flex ms-3">
                <i class="me-2">-</i
                ><span
                  >Acceptance Date:
                  {{ formatDate(new Date(tableData.acceptanceDate)) }}</span
                >
              </div>
              <div class="d-flex ms-3">
                <i class="me-2">-</i
                ><span
                  >Processed By:
                  {{
                    tableData.applicationUser
                      ? tableData.applicationUser.completeName
                      : "n/a"
                  }}</span
                >
              </div>
            </div>
            <div class="col-md-9 border-start border-3">
              <div class="ms-2">
                <div class="mb-2">
                  <b>Items:</b>
                </div>
                <div>
                  <table width="100%">
                    <thead>
                      <tr class="border-bottom">
                        <th class="py-2 text-center" style="width: 60px">
                          Qty
                        </th>
                        <th class="py-2">Item Name</th>
                        <th class="py-2" style="width: 200px">
                          Requisitioning Office/Dept.
                        </th>
                        <th class="py-2 text-center" style="width: 130px">
                          Unit Price
                        </th>
                        <th class="py-2 text-center" style="width: 80px">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="y in tableData.iarItems"
                        :key="y.id"
                        class="border-bottom"
                      >
                        <td class="py-2 align-top text-center text-info">
                          <b>{{ y.quantity }}</b>
                        </td>
                        <td class="py-2 pe-3 align-top">
                          <div>{{ y.itemName }}</div>
                          <small>{{ y.description }}</small>
                        </td>
                        <td class="py-2 align-top">
                          {{
                            tableData.deliveryUnit
                              ? tableData.deliveryUnit.name
                              : ""
                          }}
                        </td>
                        <td
                          class="py-2 align-top text-center"
                          :class="
                            y.isDelivered ? 'text-warning' : 'text-danger'
                          "
                        >
                          {{ formatCurrency(y.unitCost) }}
                        </td>
                        <td class="py-2 align-top text-center">
                          <div
                            class="badge p-2"
                            :class="y.isDelivered ? 'bg-success' : 'bg-danger'"
                          >
                            <b class="font-size-12">{{
                              y.isDelivered ? "DELIVERED" : "WAIVED"
                            }}</b>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </b-modal>
</template>

